import { keyBy } from 'lodash';

import {
  GET_DEGREES,
  GET_DEGREES_FAILED,
  GET_DEGREES_SUCCESS,
} from "../actions/degreeManagement.action";

const INITIAL_STATE = {
  degrees: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function degreeReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_DEGREES:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_DEGREES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        degrees: {
          ...payload,
          data: keyBy(payload.data, '_id'),
        },
      });
    case GET_DEGREES_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
